import { apiClient } from "./apiClient";
import { INgayNghi } from "../models/response/category/INgayNghi";

export const NGAY_NGHI_API_END_POINT = "ngay-nghi";

export const ngayNghiApi = {
    selectAll: () => apiClient.get(NGAY_NGHI_API_END_POINT),
    selectByCoSo: (dm_coso_id: number) => apiClient.get(`${NGAY_NGHI_API_END_POINT}/co-so/${dm_coso_id}`),
    selectById: (id: number) => apiClient.get(`${NGAY_NGHI_API_END_POINT}/${id}`),
    insert: (data: INgayNghi) => apiClient.post(NGAY_NGHI_API_END_POINT, data),
    update: (data: INgayNghi) => apiClient.put(NGAY_NGHI_API_END_POINT, data),
    delete: (id: number) => apiClient.delete(`${NGAY_NGHI_API_END_POINT}/${id}`)
};
